module.exports = __webpack_public_path__ + "img/steelcase-logo.568f86e4.svg";